import { environment } from '@lla-platform/core/core-util'

export const FORM_API_URL = {
  getOneForm: (formId: string) => `${environment.apiUrl}/form/${formId}`,
  getForms: `${environment.apiUrl}/form/get-forms`,
  submitForm: `${environment.apiUrl}/form/submit-form`,
  inspectionCompliance: `${environment.apiUrl}/form/inspection-compliance`,
  adminInspectionWindows: `${environment.apiUrl}/admin/inspection-windows`,

  getOneTireReportForm: (formId: string) =>
    `${environment.apiUrl}/tirereports/weekly-tire-report/${formId}`,
  getTireReportForms: `${environment.apiUrl}/tirereports/weekly-tire-reports`,
  submitTireReportForm: `${environment.apiUrl}/tirereports/submit-weekly-tire-report`
}
